/**
 * 从接口响应或 http reject 元组中取出可读错误文案
 * @param {*} payload - data.msg / [msg, data] / 字符串
 * @param {string} fallback
 */
export function getApiErrorMessage(payload, fallback = '操作失败') {
    if (typeof payload === 'string' && payload) {
        return payload;
    }
    if (Array.isArray(payload)) {
        const fromMsg = payload[0];
        if (typeof fromMsg === 'string' && fromMsg) {
            return fromMsg;
        }
        const fromData = getApiErrorMessage(payload[1], '');
        if (fromData) {
            return fromData;
        }
        return fallback;
    }
    if (payload && typeof payload === 'object') {
        return payload.msg || payload.message || fallback;
    }
    return fallback;
}

/**
 * 在弹窗/iframe 场景优先使用父层提示，保证错误信息可见
 * @param {Object} vm - Vue 实例
 * @param {*} payload
 * @param {string} fallback
 */
export function showApiError(vm, payload, fallback = '操作失败') {
    const msg = getApiErrorMessage(payload, fallback);
    if (typeof window !== 'undefined' && typeof window.alert === 'function') {
        window.alert(msg);
        return msg;
    }

    try {
        if (window.parent && window.parent !== window && window.parent.layer && typeof window.parent.layer.msg === 'function') {
            window.parent.layer.msg(msg, { icon: 2 });
            return msg;
        }
    } catch (e) {
        // 忽略跨域或父层不可用异常，回退到当前页面 message
    }

    if (vm && vm.$message) {
        vm.$message.error(msg);
    }
    return msg;
}
